import usePalletLocation from './hooks/usePalletLocation'
import PalletLocationView from './Components/PalletLocationView'

const PalletLocationMain = () => {
  const vm = usePalletLocation()
  return <PalletLocationView {...vm} />
}

export default PalletLocationMain
